<template>
	<div
		class="absolute top-0 right-0 left-0 z-10 flex h-14 items-center justify-between px-4 pt-3 pb-2"
	>
		<RouterLink to="/inventory" custom v-slot="{ navigate, isExactActive }">
			<Transition
				enterActiveClass="transition-all duration-500"
				enterFromClass="-translate-x-[200%] opacity-0"
			>
				<BaseButton
					color="secondary"
					size="sm"
					borderRounded
					square
					class="relative space-x-0! overflow-visible"
					:class="{
						'border-red border-2': isExactActive
					}"
					@click="navigate"
					v-if="user.uuid"
				>
					<BackpackIcon class="h-5 w-5" />
					<Transition
						enterActiveClass="transition-all duration-500"
						enterFromClass="scale-0 opacity-0"
					>
						<div
							class="bg-red text-label-primary absolute translate-x-1/2 rounded-full px-1.5 py-px text-xs leading-4.5"
							:class="{
								'-top-0.75 -right-0.5': isExactActive,
								'-top-px right-0': !isExactActive
							}"
							v-if="inventory.itemsCount"
						>
							{{ inventory.itemsCount }}
						</div>
					</Transition>
				</BaseButton>
			</Transition>
		</RouterLink>
		<BalanceButton />
		<RouterLink to="/profile" custom v-slot="{ navigate, isActive }">
			<Transition
				enterActiveClass="transition-all duration-500"
				enterFromClass="translate-x-[200%] opacity-0"
			>
				<UserXP
					@click="navigate"
					:avatar="user.avatar"
					:level="user.level"
					:levelPercent="user.levelPercent"
					v-if="user.uuid"
					:isActive="isActive"
				/>
			</Transition>
		</RouterLink>
		<div class="absolute top-0 right-0 left-0 -z-10 h-3 bg-[#000]"></div>
		<div
			class="shadow-page absolute top-0 right-0 bottom-0 left-0 -z-10 rounded-t-xl bg-linear-to-b from-black via-black to-black/0"
		></div>
	</div>
</template>
<script setup lang="ts">
import BackpackIcon from '@/assets/icons/backpack.svg'
import BaseButton from './BaseButton.vue'
import { useUser } from '@/stores/user'
import BalanceButton from './BalanceButton.vue'
import UserXP from './UserXP.vue'
import { useInventory } from '@/stores/inventory'

const user = useUser()
const inventory = useInventory()
</script>
